import { colors } from "../colors_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { identityService } from "./identityService_v2.js";
import { createAccount } from "./createAccount_v2.js";
import { tempNamePop } from "./changeNamePop_v2.js";
import { changeEmailPop } from "./changeEmailPop_v2.js";
import { changePasswordPop } from "./changePasswordPop_v2.js";
import { changeSecQAPop } from "./changeSecQAPop_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";
import { deleteAccount } from "./deleteAccount_v2.js";
import { matchService } from "../matches/matchService_v2.js";
import { forgotPassword } from "./forgotPassword_v2.js";
import { dasModal } from "../modal_v2.js";
import { verifyEmailPop } from "./verifyEmailPop_v2.js";
import { COMPUTER_NAME } from "../constants_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { subscriptionManager } from "../subscriptionManager_v2.js";
import { router } from "../router_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { matchCard } from "../matches/matchCard_v2.js";
import { join } from "../matches/join_v2.js";
import { iPop } from "../ipop_v2.js";

var profileState = {
  tempNamePop: "notVisible", // visible or notVisible
  size: "small",
};

// always in the dom
const profileNav = document.getElementById("profileNav");
const profileSection = document.getElementById("profileSection");

const getProfileSize = () => {
  return profileState.size;
};

const render = async (size) => {
  if (!utilsApp.isSizeValid(size)) {
    console.log("ERROR: Size is not valid");
    return;
  }
  profileNav.classList.add("sectionNarrow");
  const modalBehinder = document.getElementById("modalBehinder");
  switch (size) {
    case "normal":
      modalBehinder.style.display = "block";
      modalBehinder.dataset.action = "modalBehinderRenderProfileSmall";
      profileState.size = "normal";
      profileSection.style.width = utilsApp.calculateSectionWidth();
      if (identityService.gotLoggedOnUser()) {
        await renderLoggedIn();
      } else {
        await renderNotLoggedIn();
      }

      break;
    case "small":
      modalBehinder.style.display = "none";
      profileSection.style.width = "0px";
      profileSection.innerHTML = "";
      profileSection.className = "";
      profileState.size = "small";
      break;
    default:
      console.log(
        "Error: Attempting to render profile to invalid size: " + size,
      );
      return;
  }
  setColorsAndListeners();
};

const renderProfileSectionSmall = () => {
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
  render("small");
};

const renderLoggedIn = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  const name = Object.keys(pAIdentity).includes("blurb")
    ? pAIdentity.pANameHtmlBlurb
    : pAIdentity.pANameHtml;
  const htmlNormal = `
        <div id="sectionHeaderArea" class="vertical">
          <div class="menu">Profile</div>
        </div>
        <div class="profileMiddleContent">
             <h3>Welcome Back <span id="profileName">${name}</span></h3>
            <div id="profileStats">
            </div>
        </div>
    
            <div id="accountButtons">
              <button id="logOutButton" class="button workADayButtons center">Log Out</button>
              <button id ="changeNameButtonLi" class="button workADayButtons center">Change Name</button>
              <button id ="changeEmailButton" class="button workADayButtons center">Change Email</button>
              <button id ="verfyEmailButtonProfile" class="button workADayButtons center">Verify Email</button>
              <button id="changePasswordButton" class="button workADayButtons center">Change Password</button>
              <button id="changeSecQA" class="button workADayButtons center">Change Security Q&A</button>
              <button id="deleteAccountButton" class="button workADayButtons center">Delete Account</button>
              <div id="nameChangeButtons"></div>
            </div>


        <div id="profileX" class = "x"></div>
        
        `;
  profileSection.innerHTML = htmlNormal;
  profileSection.classList.add("sectionWide");
  const keys = Object.keys(pAIdentity);
  renderStats({ identity: pAIdentity, keys });
  //renderBadges({ identity: pAIdentity, keys });
  await renderNameChangeButtons();
  utilsApp.adjust4Mobile();
};

const handleVerifyEmailButton = () => {
  verifyEmailPop.render();
};

const handleDeleteAccountButton = (event) => {
  profile.render("small");
  deleteAccount.render();
};

const handleChangeSecQA = (event) => {
  profile.render("small");
  changeSecQAPop.render({ showStopSecNag: false });
};

const handleChangeEmailButton = (event) => {
  profile.render("small");
  changeEmailPop.render();
};

const handleChangePasswordButton = (event) => {
  profile.render("small");
  changePasswordPop.render();
};

const handleChangeNameButtonLi = async (event) => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;
  profile.render("small");
  tempNamePop.render(pAUserID);
};

const renderBadges = ({ identity, keys }) => {
  const badges = document.getElementById("badges");
  let html = "";
  if (keys.includes("badges")) {
    for (const badge of identity.badges) {
      html = html + `<li>Badge: <span class="courier">${badge}</span></li>`; // placeholder to at least render the ID until I get this figured out
    }
  }
  badges.innerHTML = html;
};

const renderStats = ({ identity, keys }) => {
  const profileStats = document.getElementById("profileStats");
  const totalLogIns = identity?.totalLogIns ?? 0;
  const streakDailyLogIn = identity?.streakDailyLogIn ?? 0;
  const streakWeeklyLogIn = identity?.streakWeeklyLogIn ?? 0;
  const streakWins = identity?.streakWins ?? 0;

  let html = "";
  html =
    html +
    `<div id="accountStats" class="accountStats stats"><div class="statsHeader">Account Stats:</div>`;
  html =
    html +
    `<div>Created: <span class="courier">${identity.created.month}/${identity.created.day}/${identity.created.year}</span></div>`;

  html =
    html + `<div># Log ons: <span class="courier">${totalLogIns}</span></div>`;
  html =
    html +
    `<div>Log In Daily Streak: <span class="courier">${streakDailyLogIn}</span></div>`;

  html =
    html +
    `<div>Log In Weekly Streak<div id="weeklySplainer" class="i">ⓘ</div> <span class="courier">${streakWeeklyLogIn}</span></div>`;

  html =
    html +
    `<div>Winning Streak: <span class="courier">${streakWins}</span></div>`;

  html = html + `</div>`;
  profileStats.innerHTML = html;
  document.getElementById("accountStats").style.backgroundColor =
    colors.getGameColor("tip");
};

const renderWeeklySplainer = (event) => {
  iPop.render({
    text: "Weeks start on Sunday",
    event,
  });
};

const renderNotLoggedIn = async () => {
  const htmlNormal = `
        <div id="sectionHeaderArea" class="vertical">
          <div class="menu">Profile</div>
        </div>
        <div id="profileRightColumn">
          <div class="flexRow">
            <div id="profileTopRight">
              Log In / Create Account Enables:
                <ul>
                  <li>Match History</li>
                  <li>Ranking / Leaderboard</li>
                  <li>Other People can find out</li>
                  <li>Preferences are Saved</li>
                </ul>
            </div>
            <div id="wartNouveau" class = "wartNouveau"></div>
          </div>

          <div id="profileBottomRight">
            <div id="profileRightColumnBottomLeft">
              <form id="logInForm">
                <p id="logInEmailWrapper">
                  <label class="marginTop10" for="emailProfile">Email:
                    <input id="emailProfile" class="input" type="email" autocomplete="username email"></input>
                    <div class="inputMessages" id="emailMsg"></div>
                  </label>
                </p>
                <p>
                  <label class="marginTop10" for="passwordProfile">Password:
                    <input id="passwordProfile" class="input" autocomplete="current-password" type="password"></input>
                    <div class="inputMessages" id="passwordMsg"></div>
                  </label>
                </p>
                <button id="logInButton" class="button workADayButtons center">Log In</button>
                <div class="inputMessages" id="logInMsg"></div>
              </form>
            </div>
            <div id="logInButtons">
              <button id="forgotPassword" class="button workADayButtons center">Forgot Password</button>
              <button id ="createAccount" class="button workADayButtons center">Create Account</button>
              <div id="nameChangeButtons"></div>
            </div>
          </div>
          <div id="logInTip">Tip: Bookmark this <a href="https://topagon.com/login">https://topagon.com/login</a></div>
        </div>

        
        <div id="profileX"></div>
        
        `;
  profileSection.innerHTML = htmlNormal;
  profileSection.classList.add("sectionWide");
  document.getElementById("logInForm").style.backgroundColor =
    colors.getGameColor("tip");

  const emailProfile = document.getElementById("emailProfile");
  emailProfile.style.backgroundColor = colors.getGameColor("lighterAccent");
  emailProfile.focus();

  const password = document.getElementById("passwordProfile");
  passwordProfile.style.backgroundColor = colors.getGameColor("lighterAccent");

  await renderNameChangeButtons();

  utilsApp.adjust4Mobile();
};

const renderNameChangeButtons = async () => {
  const currentMatchResult = matchService.getCurrentMatch();
  if (currentMatchResult.status != 200) {
    return; //no current Match. Get out of here
  }
  if (identityService.gotLoggedOnUser()) {
    return; // these are only when you are playingAs a temp
  }
  const currentMatch = currentMatchResult.currentMatch;
  // we are going to need the playingAs identity (cue: Extreme Ways )
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status != 200) {
    // session expired
    return { status: pAIdentityResponse.status };
  }
  const pAIdentity = pAIdentityResponse.identity;
  const pAUserID = pAIdentity.userID;

  if (
    !(currentMatch.p1UserID === pAUserID || currentMatch.p2UserID === pAUserID)
  ) {
    return;
    // if a temp identity is NOT a player, get out of here. No name changes for them.
    // (they are just watching)
  }
  let html = ``;

  let p1UserID = currentMatch.p1UserID;
  if (
    !(
      currentMatch.p1Name === "waiting" || currentMatch.p1Name === COMPUTER_NAME
    )
  ) {
    // Debug logging for profile p1 identity lookup
    console.log("profile_v2 p1IdentityResult: p1UserID =", p1UserID, "type =", typeof p1UserID);
    console.log("profile_v2 p1IdentityResult: call stack:", new Error().stack);
    
    const p1IdentityResult = await identityService.getIdentity(p1UserID);
    const p1Identity = p1IdentityResult.identity;
    const buttonText = escapeHtml(identityService.parseName(currentMatch.p1Name));
    if (Object.keys(p1Identity).includes("refreshToken")) {
      // We are authoritative (we made it or user logged in)
      // In other words, it's not an identity loaded from that database that
      // was not logged into or created in this session. Example: The opponent identity
      // that is playing on their own device. In that case, we should definitely not be changing their name.
      if (Object.keys(p1Identity.refreshToken).length > 0) {
        html =
          html +
          `<button 
            class="button tempNameButtons center" 
            id="nameChange-${p1UserID}">
            ${buttonText}
          </button>`;
      }
    }
  }

  let p2UserID = currentMatch.p2UserID;
  if (
    !(
      currentMatch.p2Name === "waiting" || currentMatch.p2Name === COMPUTER_NAME
    )
  ) {
    const p2IdentityResult = await identityService.getIdentity(
      currentMatch.p2UserID,
    );
    const p2Identity = p2IdentityResult.identity;
    const buttonText = escapeHtml(identityService.parseName(currentMatch.p2Name));
    if (Object.keys(p2Identity).includes("refreshToken")) {
      // We are authoritative (we made it or user logged in)
      // In other words, it's not an identity loaded from that database that
      // was not logged into or created in this session. Example: The opponent identity
      // that is playing on their own device. In that case, we should definitely not be changing their name.
      if (Object.keys(p2Identity.refreshToken).length > 0) {
        html =
          html +
          `<button class="button tempNameButtons center" 
            id="nameChange-${p2UserID}">
            ${buttonText}
          </button>`;
      }
    }
  }

  if (html.length > 0) {
    html =
      `<div id="tempNames" class="flexRow">
        <div id="proLeft" class="profileVertical">Name Change</div>
        <div id="proRigth" class="flexColumn">
    ` +
      html +
      `</div></div>`;
  }

  document.getElementById("nameChangeButtons").innerHTML = html;
  eventHub.registerEvent(
    "click",
    `nameChange-${p1UserID}`,
    handleTempNameChange,
  );
  eventHub.registerEvent(
    "click",
    `nameChange-${p2UserID}`,
    handleTempNameChange,
  );
  const tempNames = document.getElementById("tempNames");
  if (document.body.contains(tempNames)) {
    tempNames.style.backgroundColor = colors.getGameColor("tip");
  }
};

const handleTempNameChange = (event, element) => {
  const userID = element.id.split("-")[1];
  profile.render("small");
  tempNamePop.render(userID);
};

const setColorsAndListeners = () => {
  colors.setNavColors();
  profileSection.style.borderColor = colors.getGameColor("hexGrid");
  profileNav.style.borderColor = colors.getGameColor("hexGrid");
  colors.setButtonColors();
};

const handleProfileSectionClick = () => {
  switch (profile.size()) {
    case "small":
      render("normal");
      break;
    case "normal":
      render("small");
      break;
    default:
      render("small");
  }
};

const handleEmailProfileKeyUp = (event) => {
  event.stopPropagation();
  const email = document.getElementById("emailProfile").value;
  const messageElement = document.getElementById("emailMsg");
  const result = identityService.isEmailValid(email);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handlePasswordProfileKeyUp = (event) => {
  event.stopPropagation();
  const password = document.getElementById("passwordProfile").value;
  const messageElement = document.getElementById("passwordMsg");
  const result = identityService.isPasswordValid(password);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

/**
 * @brief Main handler for the login submission event.
 * @description Validates input, manages loading states, and delegates post-login navigation.
 * @async
 * @param {Event} event - The form submission event.
 */
const handleLogIn = async (event) => {
  const credentials = getLoginInputs();

  // Validation
  if (!isLoginInputValid(credentials)) return;

  // UI State: Loading
  setLoginLoadingState(true);

  // Execution
  const result = await identityService.logOn(credentials);

  if (result.status !== 200) {
    handleLoginFailure(result.message);
    return;
  }

  //Success Flow
  await handleLoginSuccess();
};

/**
 * @brief Retrieves login credentials and UI elements from the DOM.
 * @returns {Object} Elements and values for email and password.
 */
const getLoginInputs = () => {
  const emailElem = document.getElementById("emailProfile");
  const passElem = document.getElementById("passwordProfile");
  return {
    email: emailElem.value,
    password: passElem.value,
    emailElem,
    passElem,
    logInMsg: document.getElementById("logInMsg"),
  };
};

/**
 * @brief Validates user input before submission.
 * @description Checks for empty fields and existing validation error messages.
 * @param {Object} fields - The object returned by getLoginInputs.
 * @returns {boolean} True if input is valid.
 */
const isLoginInputValid = (fields) => {
  const { email, password, emailElem, passElem, logInMsg } = fields;

  // Check empty values or existing error indicators
  if (
    email.length === 0 ||
    document.getElementById("emailMsg").innerText.length > 0
  ) {
    logInMsg.innerText = "Please enter your email.";
    emailElem.focus();
    return false;
  }
  if (
    password.length === 0 ||
    document.getElementById("passwordMsg").innerText.length > 0
  ) {
    logInMsg.innerText = "Please enter your password.";
    passElem.focus();
    return false;
  }
  return true;
};

/**
 * @brief Toggles the UI between 'loading' and 'default' states.
 * @description Adjusts cursors, button disabled status, and submission messages.
 * @param {boolean} isLoading - Whether the application is currently submitting.
 */
const setLoginLoadingState = (isLoading) => {
  const logInButton = document.getElementById("logInButton");
  const state = isLoading ? "wait" : "default";

  document.body.style.cursor = state;
  if (logInButton) {
    logInButton.style.cursor = state;
    logInButton.disabled = isLoading;
  }

  if (isLoading) {
    document.getElementById("logInMsg").innerText = "Submitting...";
  }
};

/**
 * @brief Handles failed login attempts.
 * @description Reverts UI state and displays error messages from the server.
 * @param {string} message - The error message to display.
 */
const handleLoginFailure = (message) => {
  const { emailElem, logInMsg } = getLoginInputs();
  setLoginLoadingState(false);
  logInMsg.innerText = message;
  emailElem.focus();
};

/**
 * @brief Manages the sequence of events after a successful login.
 * @description Checks for URL joins, email verification, and security setup in priority order.
 * @async
 */
const handleLoginSuccess = async () => {
  const pAIdentityResponse = await identityService.getPlayingAs();
  if (pAIdentityResponse.status !== 200) return;

  const identity = pAIdentityResponse.identity;
  setLoginLoadingState(false);
  postLogInUX(identity);

  // Priority 1: URL Join
  const urlJoinCode = router.getURLJoinCode();
  if (urlJoinCode.length > 0) {
    await join.joinByURL(urlJoinCode);
    return;
  }

  // Priority 2: Email Verification
  if (!identity.emailVerified) {
    verifyEmailPop.render();
    return;
  }

  // Priority 3: Security Questions
  // The token says whether a security Q&A exists, but not what it is.
  const hasSecuritySetup = identity.hasSecQA === true;
  const isNagOptedOut = identity.stopSecNag === true;

  if (!hasSecuritySetup && !isNagOptedOut) {
    changeSecQAPop.render({ showStopSecNag: true });
    return;
  }

  // Final Action: Post-Login Popup
  if (identity.postLogPop === true) {
    renderPostLogonPop(identity);
  }
};

const postLogInUX = (pAIdentity) => {
  colors.setScheme(pAIdentity.scheme); //triggers a board render
  renderProfileSectionSmall();
};

const streaksHTML = (identity) => {
  const keys = Object.keys(identity);
  const streakDailyLogIn = identity?.streakDailyLogIn ?? 0;
  const streakWeeklyLogIn = identity?.streakWeeklyLogIn ?? 0;
  const streakWins = identity?.streakWins ?? 0;

  return `
  <div id="postLogInStreaksContainer">
    <div class="flexColum center">
      <div class="flexRowStreaks">
        <div class="streakGroup flexColumn" id="logInStreaks">
          <div class="center streakSub">Log In Streaks</div>
          <div class="left">Daily: <span class=courier>${streakDailyLogIn}</span></div>
          <div class="left">Weekly: <span class=courier>${streakWeeklyLogIn}</span></div>
        </div>
        <div class="streakGroup flexColumn" id="matchStreaks">
          <div class="center streakSub">Match Streaks</div>
          <div class="left">Winning: <span class=courier>${streakWins}</span></div>
        </div>
      </div>
    </div>
  </div>
  `;
};

// No current match: say where to go next. The ⓘ says where the buttons
// are, worked out when it's clicked (see renderPostLogNavSplainer).
const noMatchInProgressHTML = () => `
    <div id="nextSteps">There is no match in progress.<div id="postLogNavSplainer" class="i">ⓘ</div>
        <ul class="left">
          <li>The "New" button starts a new match.</li>
          <li>The "Join" button joins someone else's match.</li>
        </ul>
    </div>`;

/**
 * The "no match in progress" part of the post-logon pop, on its own (for
 * when the player ends up with no current match, e.g. removed as a watcher).
 */
const renderNoMatchInProgressPop = () => {
  dasModal.close(); // just in case
  dasModal.render(`
    <div id="postLogPopOuter">
      <div>Current Match</div>
      ${noMatchInProgressHTML()}
    </div>`);
};

const renderPostLogonPop = (identity) => {
  const currentMatchResult = matchService.getCurrentMatch();
  let popBodyHtml = noMatchInProgressHTML();
  if (currentMatchResult.status === 200) {
    const currentMatch = currentMatchResult.currentMatch;
    popBodyHtml = `
      <div id="postLogInMatchCardContainer">
        ${matchCard.generateHTML(currentMatch)}
      </div>`;
  }
  dasModal.close(); // just in case
  dasModal.render(`
    <div id="postLogPopOuter">
      <div id="postLogPopTopRow">
        Welcome Back!
      </div>
      ${streaksHTML(identity)}
      <div>Current Match</div>
      ${popBodyHtml}
      <div id="postLogPopBottomRow">
        <button id="noPostLogPopButton" class="button ">
          Don't show this again
        </button>
      </div>
    </div>
    `);

  const postLogInMatchCardContainer = document.getElementById(
    "postLogInMatchCardContainer",
  );
  document.getElementById("logInStreaks").style.backgroundColor =
    colors.getGameColor("tip");
  document.getElementById("matchStreaks").style.backgroundColor =
    colors.getGameColor("tip");
};

// The ⓘ on the Profile nav button. Clicking it shows this instead of opening
// Profile (eventHub runs the innermost registered handler and stops).
const renderProfileNavSplainer = (event) => {
  const items = identityService.gotLoggedOnUser()
    ? [
        "Log out",
        "Change your name, email, password, or security question",
        "Verify your email",
        "Delete your account",
      ]
    : [
        "Log in",
        "Create an account",
        "Reset a forgotten password",
        "Change your player name",
      ];
  iPop.render({
    text: `Use Profile to:<ul class="left">${items
      .map((item) => `<li>${item}</li>`)
      .join("")}</ul>`,
    event,
  });
};

const renderPostLogNavSplainer = (event) => {
  iPop.render({
    text: utilsApp.navIsUnderHamburger()
      ? "The New and Join buttons are under the hamburger icon at the top."
      : "The New and Join buttons are on the left.",
    event,
  });
};

const handleNoPostLogPopButton = async () => {
  document.body.style.cursor = "wait";
  await new Promise(requestAnimationFrame);
  const result = await identityService.setPostLogPop(false);
  document.body.style.cursor = "default";
  dasModal.close();
};

const handleForgotPassword = (event) => {
  profile.render("small");
  forgotPassword.render();
};

const handleCreateAccount = async (event) => {
  profile.render("small");
  createAccount.render();
};

const handleLogOut = async (event) => {
  dasModal.close();

  dasModal.render(`<div class="max">One moment while we log you out...</div>`);
  const newPlayerOne = await identityService.createIdentity({
    name: "Player One",
    type: "temp",
  });
  await identityService.setPlayingAs({
    name: newPlayerOne.identity.name,
    createMatch: false,
  });
  colors.setScheme("muted"); // will necessarily render board nad scoreboard

  renderProfileSectionSmall();
  subscriptionManager.closeAllSubscriptions();
  board.render();
  scoreBoard.render();
  colors.setButtonColors();
  dasModal.close();
  dasModal.render(
    `<div class="max">The account is logged out. You are now playing as a temporary identity.</div>`,
  );
};

const closePostLogPop = () => {
  dasModal.close();
};

eventHub.registerEvent(
  "click",
  "modalBehinderRenderProfileSmall",
  renderProfileSectionSmall,
);
eventHub.registerEvent("click", "profileX", renderProfileSectionSmall);
eventHub.registerEvent("click", "logOutButton", handleLogOut);
eventHub.registerEvent("click", "changeNameButtonLi", handleChangeNameButtonLi);
eventHub.registerEvent("click", "changeEmailButton", handleChangeEmailButton);
eventHub.registerEvent(
  "click",
  "verfyEmailButtonProfile",
  handleVerifyEmailButton,
);
eventHub.registerEvent(
  "click",
  "changePasswordButton",
  handleChangePasswordButton,
);
eventHub.registerEvent("click", "changeSecQA", handleChangeSecQA);
eventHub.registerEvent(
  "click",
  "deleteAccountButton",
  handleDeleteAccountButton,
);
eventHub.registerEvent("submit", "logInForm", handleLogIn);
eventHub.registerEvent("keyup", "emailProfile", handleEmailProfileKeyUp);
eventHub.registerEvent("keyup", "passwordProfile", handlePasswordProfileKeyUp);
eventHub.registerEvent("click", "forgotPassword", handleForgotPassword);
eventHub.registerEvent("click", "createAccount", handleCreateAccount);
eventHub.registerEvent("click", "profileNav", handleProfileSectionClick);
eventHub.registerEvent("click", "noPostLogPopButton", handleNoPostLogPopButton);
eventHub.registerEvent("click", "postLogNavSplainer", renderPostLogNavSplainer);
eventHub.registerEvent("click", "profileNavSplainer", renderProfileNavSplainer);
eventHub.registerEvent("click", "postLogInMatchCardContainer", closePostLogPop);

eventHub.registerEvent("click", "weeklySplainer", renderWeeklySplainer);

export const profile = {
  size: getProfileSize,
  render,
  renderNoMatchInProgressPop,
  logOff: handleLogOut,
};
